































































































































































































import axios from 'axios';
import i18n from 'vue-i18n';
import Vue from 'vue';
import { addHours, addDays, addMonths, addYears, getUnixTime } from 'date-fns';
import CoAlert from '@/components/Molecules/co-alert/CoAlert.vue';
import CoCardPlan from '@/components/Molecules/co-card-plan/CoCardPlan.vue';
import CoDate from '../../../components/Molecules/co-date/CoDate.vue';
import EventBus from '../../../eventBus';
import CoDropdown from '@/components/Molecules/co-dropdown/CoDropdown.vue';
import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
import CoDropdownItem from '@/components/Molecules/co-dropdown-item/CoDropdownItem.vue';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoConfirmation from '@/components/Molecules/co-confirmation/CoConfirmation.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';

export default {
    i18n: {
        messages: {
            en: {
                cancellationconfimation: 'Your subscription was cancelled. It will terminate on {date}',
                renewinfo:
                    'The upcoming change of your subscription will be aborted and your current subscription preserved. Do you want to continue?',
                noplan: 'You currently have no plan.',
                complexplaninfo: 'You have a special plan configuration. To change your plan please contact the team.',
                changedyourmind: 'Changed your mind? ',
                undocancellation: 'Undo your plan cancellation.',
                cancelplanareyousure:
                    'Are you sure you want to cancel your subscription? You will lose access to all features and content.',
                keepmembership: 'Keep plan',
                cancelationdateinfo:
                    'If you cancel your membership now, your subscription will be cancelled on {date} according to the minimum contract period of {minTerm} {minTermUnit} and the cancellation notice period of {notice} days.',
                cancellationdateloading: 'Loading cancellation date information...',
                errorloadingcancellationdate: 'Could not load cancellation date information.',
            },
            de: {
                cancellationconfimation: 'Deine Mitgliedschaft ist gekündigt. Sie endet am {date}',
                renewinfo:
                    'Deine geplante Tarifänderung wird storniert und dein bestehender Tarif bleibt bestehen. Willst du fortfahren?',
                noplan: 'Du hast derzeit keinen Tarif.',
                complexplaninfo:
                    'Du hast eine besondere Tarifkonfiguration. Bitte spreche unser Team an, um deinen Tarif zu ändern oder zu kündigen.',
                changedyourmind: 'Du hast es dir anders überlegt?',
                undocancellation: 'Mach deine Kündigung rückgängig.',
                cancelplanareyousure:
                    'Bist du sicher, dass du deinen Tarif kündigen möchtest? Du verlierst den Zugang zu allen Funktionen und Inhalten.',
                keepmembership: 'Tarif behalten',
                cancelationdateinfo:
                    'Wenn du deinen Tarif jetzt kündigst, endet deine Mitgliedschaft am {date} gemäß der Mindestvertragslaufzeit von {minTerm} {minTermUnit} und der Kündigungsfrist von {notice} Tagen.',
                cancellationdateloading: 'Lade Informationen zum Kündigungsdatum...',
                errorloadingcancellationdate: 'Konnte die Informationen zum Kündigungsdatum nicht laden.',
            },
        },
    },
    name: 'CurrentPlanView',
    components: {
        CoAlert,
        CoHeadline,
        CoDate,
        CoButton,
        CoCardPlan,
        CoConfirmation,
        CoCard,
        CoText,
        CoDropdown,
        CoDropdownItem,
    },
    data() {
        return {
            startsAt: null,
            cancelledTo: null,
            upcoming: null,
            plan: null,
            me: this.$store.state.me,
            imageURL: '',
            loading: false,

            Membership: {},
            invoicesLoading: false,
            nextInvoice: null,

            nextPossibleCancellationDate: null,
            cancellationDateLoading: false,
        };
    },
    created() {
        // redirect to account page if billing is not turned on
        if (this.$store && this.$store.state && !this.$store.state.billingTurnedOn) {
            this.$router.push('/account');
        }
        this.getMyPlan();
        this.getUserMembership();
        this.getNextInvoice();
        this.getNextPossibleCancellationDate();
    },
    computed: {
        leastTermUnit() {
            switch (this.plan.LeastTermTimeUnit) {
                case 'Hour':
                    return this.$tc('units.hours', this.plan.LeastTerm);
                case 'Day':
                    return this.$tc('units.days', this.plan.LeastTerm);
                case 'Month':
                    return this.$tc('units.months', this.plan.LeastTerm);
                case 'Year':
                    return this.$tc('units.years', this.plan.LeastTerm);
                default:
                    return '';
            }
        },
    },
    methods: {
        showCancelUpcomingPlanModal() {
            this.$bvModal.show('cancel-scheduled-change-modal');
        },
        viewPlanDetails(type) {
            this.$router.push(`/account/plan/view/${type}`);
        },
        isMembershipComplex() {
            return (
                this.Membership &&
                (this.Membership.parentPlanUserID ||
                    (this.Membership.childPlans && this.Membership.childPlans.length > 0))
            );
        },
        getUserMembership() {
            axios({
                method: 'GET',
                url: `/membership`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        // cast response to UserMembership
                        this.Membership = response.data;
                    }
                })
                .catch((error) => {
                    this.Membership = {
                        status: 'UNSPECIFIED',
                        stripeCustomerLink: null,
                        stripeCustomerID: '',

                        currentBillingPeriodStart: null, // unix timestamp in seconds when the current billing period started
                        currentBillingPeriodEnd: null, // unix timestamp in seconds when the current billing period ends
                        billingCycleAnchor: null, // unix timestamp in seconds when the billing cycle anchor was set
                        cancelAt: null, // unix timestamp in seconds when the subscription will be canceled
                        canceledAt: null, // unix timestamp in seconds when the subscription was canceled
                        startDate: null, // unix timestamp in seconds when the subscription was created
                        endedAt: null, // unix timestamp in seconds when the subscription ended
                        created: null, // unix timestamp in seconds when the membership was created
                    };
                    console.log(error);
                })
                .finally(() => {});
        },

        getMyPlan() {
            this.loading = true;

            axios({
                method: 'GET',
                url: '/me/plan',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        this.plan = response.data.current.Plan;
                        this.startsAt = response.data.current.StartsAt;
                        this.cancelledTo = response.data.current.CancelledAt;
                        if (response.data.upcoming) {
                            this.upcoming = response.data.upcoming;
                        } else {
                            this.upcoming = null;
                        }
                    }
                    this.loading = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.loading = false;
                });
        },
        cancelMyPlan() {
            this.loading = true;

            axios({
                method: 'DELETE',
                url: '/me/plan',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.loading = false;
                    this.getMyPlan();
                })
                .catch((error) => {
                    console.log(error);
                    this.loading = false;
                });
        },
        cancelUpcomingPlan() {
            this.loading = true;

            axios({
                method: 'DELETE',
                url: '/me/plan/upcomming',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.loading = false;
                    this.getMyPlan();
                })
                .catch((error) => {
                    console.log(error);
                    this.loading = false;
                });
        },

        reactivatePlan() {
            this.loading = true;

            axios({
                method: 'POST',
                url: '/me/renew-plan',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.loading = false;
                    this.getMyPlan();
                })
                .catch((error) => {
                    console.log(error);
                    this.loading = false;
                });
        },

        getNextInvoice() {
            this.invoicesLoading = true;
            axios
                .get('/user/account/billing/invoices')
                .then((response) => {
                    this.nextInvoice = response.data?.UpcomingInvoice || null;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.invoicesLoading = false;
                });
        },

        getNextPossibleCancellationDate() {
            this.nextPossibleCancellationDate = null;
            this.cancellationDateLoading = true;

            axios
                .get('/me/plan/next-possible-cancellation-date')
                .then((response) => {
                    this.nextPossibleCancellationDate = response.data?.CancelPossibleAt || null;
                })
                .catch((error) => {
                    console.log('Could not fetch next possible cancellation date:', error);
                })
                .finally(() => {
                    this.cancellationDateLoading = false;
                });
        },
    },
};
